<template>
  <div id="replace-download-bar"
       class="customize-header-layout"
  >
    <slot name="header"></slot>
    <div class="container"
         :style="containerStyle"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getRouterViewHeight, isAppWebView } from '@/utils';

  export default {
    name: 'CustomizeHeaderLayout',
    computed: {
      ...mapGetters([
        'scrollToHideDownloadBar',
      ]),
      containerStyle() {
        if (this.isAppWebView) {
          return '';
        }
        const { scrollToHideDownloadBar } = this;
        const style = {};
        if (scrollToHideDownloadBar) {
          style.height = '100%';
        } else {
          style.height = getRouterViewHeight();
        }
        return style;
      },
    },
    methods: {
      isAppWebView,
    },
  };
</script>

<style scoped lang="less">

  .customize-header-layout {
    height: 100vh;
    height: 100%;
  }

  .container {
    height: 100vh;
    height: 100%;
    overflow: scroll;
    background-color: inherit;
  }

</style>
